import type { SurveyState } from './types';

const getters = {
  getAllSurveys(state: SurveyState) {
    return Object.values(state.surveys);
  }
};

export type SurveyGetters = {
  [k in keyof typeof getters]: ReturnType<(typeof getters)[k]>;
};

export default getters;
